module.exports = __webpack_public_path__ + "static/img/14.b82dda39.png";